import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment-timezone';
import * as _ from 'lodash';
@Pipe({
    name: 'stringTimeToDate'
})
export class StringTimeToDatePipe implements PipeTransform {
    // Takes in a string date and converts it to date, using format e.g. 'LLLL', or relative time e.g. 'yesterday'
    /**
     *
     * @param input string time e.g. 09:00
     */
    transform(input: string): any {
        const timeToDate = moment(input, 'HH:mm');
        return timeToDate.toDate();
    }
}
